(() => {
  "use strict";

  // Safe debounce: reuse window.debounce if already defined
  const debounce = window.debounce || function(func, wait, immediate) {
    let timeout;
    return function() {
      const context = this, args = arguments;
      const later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };

  // CSSSlider definition
  if (typeof CSSSlider !== 'function') {

    class CSSSlider extends HTMLElement {

      constructor() {
        super();

        this._cachedWidths = null;
        this._lastWindowWidth = window.innerWidth;
        this._currentTranslate = 0;

        document.addEventListener('stateBasedContent:loaded', (e) => {
          if (!this.sliderEnabled) {
            this.initSlider();
          } else {
            this.resetSlider();
          }
        })

        this._touchScreen = document.body.classList.contains('touchevents');
        this._rtl = document.documentElement.getAttribute('dir') == 'rtl';

        // options
        this.o = {
          selector: '.css-slide',
          snapping: true,
          groupCells: false,
          autoHeight: false,
          navigation: true,
          navigationDOM: `<span class="css-slider-button css-slider-prev" style="display:none">←</span>
                          <span class="css-slider-button css-slider-next" style="display:none">→</span>`,
          thumbnails: true,
          thumbnailsDOM: `<div class="css-slider-dot-navigation" style="display:none"></div>`,
          indexNav: false,
          indexNavDOM: `<div class="css-slider-index-navigation"><span class="css-slider-current">1</span> / <span class="css-slider-total">1</span></div>`,
          watchCSS: false,
          undisplay: false,
          disableSwipe: false,
          listenScroll: false,
          observer: true,
          autoplay: 0,
          ...JSON.parse(this.dataset.options || '{}')
        };

        if (!this.o.watchCSS) {
          this.initSlider();
        } else {
          this.RESIZE_WATCHER = debounce(() => {
            const afterContent = window.getComputedStyle(this, ':after').content;
            if (afterContent.includes('css-slide') && !this.sliderEnabled) {
              this.initSlider();
            } else if (!afterContent.includes('css-slide') && this.sliderEnabled) {
              this.destroySlider();
            }
          }, 100);
          window.addEventListener('resize', this.RESIZE_WATCHER);
          this.RESIZE_WATCHER();
        }
      }

      moveSpecialOffer() {
        const specialOffer = document.querySelector(".product-item__frame-content");
        if (specialOffer) {
          document.querySelector("product-page .product-gallery css-slider").insertBefore(specialOffer, null);
        }
      }

      destroySlider() {
        this.innerHTML = `${this.originalHTML}`;
        this.classList.remove('enabled');
        this.sliderEnabled = false;
        window.removeEventListener('resize', this.RESIZE_EVENT);
        window.removeEventListener('scroll', this.SCROLL_EVENT);
        window.removeEventListener('scroll', this.SCROLL_EVENT_ANIMATION);
      }

      initSlider() {
        this._readyEvent = new CustomEvent('ready');
        this._changeEvent = new CustomEvent('change');
        this._scrollEvent = new CustomEvent('scroll');
        this._navEvent = new CustomEvent('navigation');
        this._resetEvent = new CustomEvent('reset');
        this._pointerDownEvent = new CustomEvent('pointerDown');
        this._pointerUpEvent = new CustomEvent('pointerUp');

        this.classList.add('css-slider');
        this.originalHTML = this.innerHTML;
        this.innerHTML = `<div class="css-slider-viewport">
                            <div class="css-slider-holder">
                              <div class="css-slider-container">
                                ${this.originalHTML}
                              </div>
                            </div>
                          </div>`;

        this._containerEl = this.querySelector('.css-slider-container');
        this._containerWidth = this._containerEl.offsetWidth; 

        if (this.o.undisplay) {
          this.querySelectorAll(`${this.o.selector}`).forEach(elm => elm.style.display = 'block');
        }
        if (this.o.selector != '.css-slide') {
          this.querySelectorAll(`${this.o.selector}`).forEach(elm => elm.classList.add('css-slide'));
        }

        this.element = this.querySelector('.css-slider-holder');
        this.items = this.querySelectorAll(`${this.o.selector}`);
        this.indexedItems = [];
        this.index = 0;
        this.length = this.items.length;
        this.windowWidth = window.innerWidth;
        this.viewport = this.querySelector('.css-slider-viewport');
        if (this.o.autoHeight) this.viewport.classList.add('auto-height');

        // Navigation & thumbnails
        if (this.o.navigation || this.o.thumbnails || this.o.indexNav) {
          let container = document.createElement('div');
          container.classList.add('css-slider-navigation-container');
          container.innerHTML = `
            ${this.o.navigation ? this.o.navigationDOM : ''}
            ${this.o.thumbnails ? this.o.thumbnailsDOM : ''}
            ${this.o.indexNav ? this.o.indexNavDOM : ''}`;

          if (this.o.navigation) {
            this.prevEl = container.querySelector('.css-slider-prev');
            this.prevEl.addEventListener('click', e => { e.preventDefault(); this.changeSlide('prev'); this.dispatchEvent(this._navEvent); });
            this.nextEl = container.querySelector('.css-slider-next');
            this.nextEl.addEventListener('click', e => { e.preventDefault(); this.changeSlide('next'); this.dispatchEvent(this._navEvent); });
          }

          if (this.o.thumbnails) this.thumbnailsEl = container.querySelector('.css-slider-dot-navigation');
          if (this.o.indexNav) { this.indexEl = container.querySelector('.css-slider-current'); this.lengthEl = container.querySelector('.css-slider-total'); }

          this.append(container);
        }

        if (this.length > 1) {
          // Scroll event
          this.SCROLL_EVENT = debounce(() => {
            if (!this._sliderBlockScroll) {
              const scrollItems = this.indexedItems.entries();
              const scrollArray = Array.from(scrollItems, elm => Math.abs(elm[1].offsetLeft - this.element.scrollLeft));
              const scrollDistance = Math.min(...scrollArray);
              const scrollIndex = scrollArray.indexOf(scrollDistance);
              if (scrollIndex != this.index) {
                this.index = scrollIndex;
                this.checkSlide();
                this.dispatchEvent(this._changeEvent);
              }
            }
          }, 50);

          this.element.addEventListener('scroll', this.SCROLL_EVENT, { passive: true });

          // Resize
          this.RESIZE_EVENT = debounce(() => {
            if (this.windowWidth != window.innerWidth && this.o.groupCells) this.resetSlider();
            if (!this.o.groupCells) this.checkSlide();
            this.windowWidth = window.innerWidth;
          }, 100);
          window.addEventListener('resize', this.RESIZE_EVENT);

          this.resetSlider(true);
        }

        this.classList.add('enabled');
        this.sliderEnabled = true;
        this.dispatchEvent(this._readyEvent);

        if (parseInt(this.o.autoplay) > 0) this._initAutoplay();
        this.moveSpecialOffer();
      }

      changeSlide(direction, behavior = 'smooth') {
        if (direction == 'next') { if (this.index + 1 < this.length) this.index++; }
        else if (direction == 'prev') { if (this.index - 1 >= 0) this.index--; }
        else if (parseInt(direction) >= 0) this.index = parseInt(direction);

        // Calculate translateX inside the method
        const targetOffset = this.indexedItems[this.index].offsetLeft - parseInt(getComputedStyle(this.indexedItems[0]).marginLeft);
        const containerWidth = this._containerEl.offsetWidth;

        const translateX = this._rtl
            ? -(this._containerEl.scrollWidth - containerWidth - targetOffset)
            : -targetOffset;

        this._currentTranslate = translateX;

        this._containerEl.style.transition = behavior === 'smooth' ? 'transform 0.4s ease' : 'none';
        if (targetOffset != 0 && this.classList.contains('custom-css-slider')) {
          this._containerEl.style.transform = `translateX(${-214}px)`;
        } else {
          this._containerEl.style.transform = `translateX(${translateX}px)`;
        }

        this.checkSlide();
        this.dispatchEvent(this._changeEvent);
      }

      checkSlide() {
        if (this.o.navigation) {
          this.nextEl.classList.remove('disabled'); this.prevEl.classList.remove('disabled');
          this.prevEl.classList.remove('deactivated'); this.nextEl.classList.remove('deactivated');
          if (this.index == 0) { this.prevEl.classList.add('disabled'); this.prevEl.classList.add('deactivated'); }
          if (this.index == this.length - 1) { this.nextEl.classList.add('disabled'); this.nextEl.classList.add('deactivated'); }
        }
        if (this.o.thumbnails && this.thumbnails) { this.thumbnails.forEach(elm => elm.classList.remove('active')); this.thumbnails[this.index]?.classList.add('active'); }
        if (this.o.indexNav) this.indexEl.textContent = this.index + 1;
        if (this.o.autoHeight) this.viewport.style.height = this.indexedItems[this.index].offsetHeight + 'px';
        this.indexedItems.forEach((elm, i) => { 
          const prevActive = this.indexedItems[this.prevIndex];
          if (prevActive) prevActive.classList.remove('css-slide-active');
          const current = this.indexedItems[this.index];
          if (current) current.classList.add('css-slide-active');
          this.prevIndex = this.index;
        });
        if (parseInt(this.o.autoplay) > 0) this._initAutoplay();
      }

      _initAutoplay() {
        if (this._autoplayInterval) clearInterval(this._autoplayInterval);
        this._autoplayInterval = setInterval(() => {
          if (this.index + 1 == this.length) this.changeSlide(0);
          else this.changeSlide('next');
        }, parseInt(this.o.autoplay));
      }

      resetSlider(nojump = false, resetIndex = true) {
        let slidesWidth = 0, page = 0, hideNavigation = false;
        this.slidesPerPage = 0;
        this.indexedItems = [];
        this.element.classList.add('disable-snapping');

        // Clear cached widths if window resized
        if (!this._cachedWidths || this._lastWindowWidth !== window.innerWidth) {
          this._cachedWidths = [];
          this._lastWindowWidth = window.innerWidth;
        }

        if (!this._containerWidth || this._lastWindowWidth !== window.innerWidth) {
            this._containerWidth = this._containerEl.offsetWidth;
            this._lastWindowWidth = window.innerWidth;
        }
        const containerWidth = this._containerWidth;

        for (let i = 0, len = this.items.length; i < len; i++) {
          const elm = this.items[i];
          elm.classList.remove('css-slide--snap');

          // Use cached width or read once
          let width = this._cachedWidths[i];
          if (width === undefined) {
            width = elm.getBoundingClientRect().width;
            this._cachedWidths[i] = width;
          }

          slidesWidth += width + 10; // or use computed margin if needed

          if (slidesWidth > containerWidth && this.slidesPerPage === 0) {
            this.slidesPerPage = i;
          }
        }

        if (this.slidesPerPage === 0) {
          this.slidesPerPage = this.items.length;
          hideNavigation = true;
        }

        for (let i = 0; i < this.items.length; i++) {
          if (i % this.slidesPerPage === 0) {
            this.items[i].classList.add('css-slide--snap');
            this.items[i].setAttribute('data-index', page++);
          }
        }

        this.indexedItems = this.querySelectorAll(`${this.o.selector}.css-slide--snap`);
        if (resetIndex) this.index = 0;
        this.length = Math.ceil(this.items.length / this.slidesPerPage);

        if (this.o.thumbnails) {
          this.thumbnailsEl.innerHTML = '';
          for (let i = 0; i < this.length; i++) {
            const dot = document.createElement('span');
            dot.classList.add('css-slider-dot');
            dot.dataset.index = i;
            this.thumbnailsEl.appendChild(dot);
            dot.addEventListener('click', e => this.changeSlide(e.target.dataset.index));
          }
          this.thumbnailsEl.style.setProperty('--size', this.length);
          this.thumbnails = this.thumbnailsEl.querySelectorAll('.css-slider-dot');
        }

        if (this.o.indexNav) {
          this.indexEl.textContent = this.index + 1;
          this.lengthEl.textContent = this.length;
        }

        if (hideNavigation) {
          this.element.classList.add('css-slider--no-drag');
          if (this.o.navigation) { this.prevEl.style.display = 'none'; this.nextEl.style.display = 'none'; }
          if (this.o.thumbnails) this.thumbnailsEl.style.display = 'none';
        } else {
          this.element.classList.remove('css-slider--no-drag');
          if (this.o.navigation) { this.prevEl.style.display = 'block'; this.nextEl.style.display = 'block'; }
          if (this.o.thumbnails) this.thumbnailsEl.style.display = 'block';
        }

        this.checkSlide();
        if (!nojump) this.element.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        this.element.classList.remove('disable-snapping');
      }
    }

    if (!customElements.get('css-slider')) customElements.define('css-slider', CSSSlider);

    document.addEventListener('shopify:section:load', e => {
      if (e.target.classList.contains('mount-css-slider') && e.target.querySelector('css-slider')) {
        e.target.querySelectorAll('css-slider').forEach(slider => { if (slider.enabled) slider.resetSlider() });
      }
    });
  }

  // Smooth scroll polyfill (same logic from your original)
  !function () { 
    function polyfill() {
      "use strict";
      const o = window, t = document;
      if (!("scrollBehavior" in t.documentElement.style && o.__forceSmoothScrollPolyfill !== true)) {

        const e = o.HTMLElement || o.Element,
              r = 468, // animation duration in ms
              i = {
                scroll: o.scroll || o.scrollTo,
                scrollBy: o.scrollBy,
                elementScroll: e.prototype.scroll || function(x, y){ this.scrollLeft = x; this.scrollTop = y; },
                scrollIntoView: e.prototype.scrollIntoView
              },
              s = o.performance && o.performance.now ? o.performance.now.bind(o.performance) : Date.now,
              c = /MSIE |Trident\/|Edge\//.test(o.navigator.userAgent) ? 1 : 0;

        function n(x, y){ this.scrollLeft = x; this.scrollTop = y; }

        function f(arg){
          if (!arg || typeof arg !== 'object' || !arg.behavior || arg.behavior === 'auto' || arg.behavior === 'instant') return true;
          if (typeof arg === 'object' && arg.behavior === 'smooth') return false;
          throw new TypeError("behavior member of ScrollOptions " + arg.behavior + " is not valid");
        }

        function p(el, axis){ return axis === "Y" ? el.clientHeight + c < el.scrollHeight : axis === "X" ? el.clientWidth + c < el.scrollWidth : undefined; }
        function a(el, axis){ const o = axis==="Y"?"overflowY":"overflowX"; const val = window.getComputedStyle(el)[o]; return val === "auto" || val === "scroll"; }

        function d(timing) {
          let n = (s() - timing.startTime)/r;
          n = n>1?1:n;
          const l = 0.5 * (1 - Math.cos(Math.PI * n));
          const e = timing.startX + (timing.x - timing.startX) * l;
          const y = timing.startY + (timing.y - timing.startY) * l;
          timing.method.call(timing.scrollable, e, y);
          if(e!==timing.x || y!==timing.y) o.requestAnimationFrame(d.bind(o, timing));
        }

        function h(el, x, y){
          let startX, startY, method, scrollable;
          if(el===t.body){
            scrollable=o;
            startX=o.scrollX||o.pageXOffset;
            startY=o.scrollY||o.pageYOffset;
            method=i.scroll;
          } else {
            scrollable=el;
            startX=el.scrollLeft;
            startY=el.scrollTop;
            method=n;
          }
          d({scrollable, method, startTime:s(), startX, startY, x, y});
        }

        o.scroll = o.scrollTo = function(){
          if(arguments[0]!==undefined){
            if(!f(arguments[0])){
              let arg = arguments[0];
              h(t.body, arg.left !== undefined ? ~~arg.left : o.scrollX || o.pageXOffset, arg.top !== undefined ? ~~arg.top : o.scrollY || o.pageYOffset);
            } else i.scroll.call(o, arguments[0].left !== undefined ? arguments[0].left : arguments[0], arguments[0].top !== undefined ? arguments[0].top : arguments[1]);
          }
        };

        o.scrollBy = function(){
          if(arguments[0]!==undefined){
            if(f(arguments[0])) i.scrollBy.call(o, arguments[0].left !== undefined ? arguments[0].left : arguments[0], arguments[0].top !== undefined ? arguments[0].top : arguments[1]);
            else{
              let x = (arguments[0].left !== undefined ? ~~arguments[0].left : ~~arguments[0]) + (o.scrollX || o.pageXOffset);
              let y = (arguments[0].top !== undefined ? ~~arguments[0].top : 0) + (o.scrollY || o.pageYOffset);
              h(t.body, x, y);
            }
          }
        };

        e.prototype.scroll = e.prototype.scrollTo = function(){
          if(arguments[0]!==undefined){
            if(!f(arguments[0])){
              let arg = arguments[0];
              h(this, arg.left!==undefined?~~arg.left:this.scrollLeft, arg.top!==undefined?~~arg.top:this.scrollTop);
            } else i.elementScroll.call(this, arguments[0].left!==undefined?~~arguments[0].left:arguments[0], arguments[0].top!==undefined?~~arguments[0].top:arguments[1]);
          }
        };

        e.prototype.scrollBy = function(){
          if(arguments[0]!==undefined){
            if(!f(arguments[0])) this.scroll({ left: (arguments[0].left||0)+this.scrollLeft, top: (arguments[0].top||0)+this.scrollTop, behavior:arguments[0].behavior });
            else i.elementScroll.call(this, (arguments[0].left||0)+this.scrollLeft, (arguments[0].top||0)+this.scrollTop);
          }
        };

        e.prototype.scrollIntoView = function(){
          if(!f(arguments[0])){
            const parent = (function(el){
              while(el!==t.body && !(p(el,"Y")&&a(el,"Y") || p(el,"X")&&a(el,"X"))){ el=el.parentNode||el.host; } return el;
            })(this);

            const rectParent = parent.getBoundingClientRect();
            const rect = this.getBoundingClientRect();
            if(parent!==t.body){
              h(parent, parent.scrollLeft+rect.left-rectParent.left, parent.scrollTop+rect.top-rectParent.top);
              if(getComputedStyle(parent).position!=="fixed") o.scrollBy({left:rect.left, top:rect.top, behavior:"smooth"});
            } else o.scrollBy({left:rect.left, top:rect.top, behavior:"smooth"});
          } else i.scrollIntoView.call(this, arguments[0]===undefined?true:arguments[0]);
        };
      }
    }
    polyfill();
  }();

})();
